import { Drawer } from '@mui/material';

import { removeFromCart } from '@/clients/storefront/storefrontClient';
import Button from '@/components/BaseLibrary/Button/Button';
import Icon, { IconName } from '@/components/Icon/Icon';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';

const Cart: React.FC = () => {
  const { cartId, cart, isCartOpen } = useSunrunShopStore(
    'cartId',
    'cart',
    'isCartOpen'
  );
  const { setCart, setIsCartOpen } = useSunrunShopActions();

  const handleRemoveItem = async (lineId: string) => {
    if (!cartId) return;
    try {
      const updatedCart = await removeFromCart(cartId, [lineId]);
      setCart(updatedCart);
    } catch (err) {
      console.error('Error removing item:', err);
    }
  };

  const handleCheckout = async () => {
    if (cart?.checkoutUrl) {
      window.location.href = cart?.checkoutUrl;
    }
  };

  return (
    <Drawer
      anchor='right'
      open={isCartOpen}
      onClose={() => {
        setIsCartOpen(false);
      }}
      PaperProps={{ style: { width: 400 } }}
    >
      <div style={{ padding: 16 }}>
        <h2>Your Cart</h2>
        {cart?.lines.edges.length ? (
          <>
            {cart?.lines.edges.map(
              ({ node: { merchandise, id, quantity } }) => (
                <div
                  key={id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12,
                  }}
                >
                  {merchandise.image?.url && (
                    <img
                      src={merchandise.image.url}
                      alt={merchandise.image.altText || 'Product Image'}
                      style={{
                        width: 64,
                        height: 64,
                        objectFit: 'cover',
                        marginRight: 8,
                      }}
                    />
                  )}
                  <div style={{ flexGrow: 1 }}>
                    <div>{merchandise.product?.title || merchandise.title}</div>
                    <div>Variant: {merchandise.title}</div>
                    <div>Quantity: {quantity}</div>
                  </div>
                  <button
                    onClick={() => handleRemoveItem(id)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <Icon name={IconName.CLOSE} />
                  </button>
                </div>
              )
            )}
            <Button onClick={handleCheckout} label='Checkout' />
          </>
        ) : (
          <p>empty</p>
        )}
      </div>
    </Drawer>
  );
};

export default Cart;
